import PropTypes from 'prop-types';
import { BsArrowCounterclockwise } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Table from '#globalComponents/Table/Table';
import { useErrorStore } from '#lib/stores/errorStore';

export const TRASH_PAGE_SIZE = 25;

function RestoreButton({ onClick, disabled }) {
	return (
		<Button onClick={onClick} disabled={disabled} variant="outline" size="sm">
			<BsArrowCounterclockwise className="w-3 h-3" />
			Wiederherstellen
		</Button>
	);
}

RestoreButton.propTypes = { onClick: PropTypes.func.isRequired, disabled: PropTypes.bool };

export function useRestoreHandler(mutation, buildMessage) {
	const showError = useErrorStore((s) => s.showError);
	const showSuccess = useErrorStore((s) => s.showSuccess);

	return async (row) => {
		try {
			await mutation.mutateAsync(row.id);
			showSuccess({ title: 'Wiederhergestellt', message: buildMessage(row), autoClose: true });
		} catch (err) {
			showError({ error: err, title: 'Wiederherstellen fehlgeschlagen' });
		}
	};
}

function TrashTable({
	rows,
	columns,
	page,
	totalPages,
	total,
	onPageChange,
	onRestore,
	isRestoring,
	emptyLabel = 'Keine gelöschten Einträge',
	...tableProps
}) {
	const actionColumn = {
		key: 'actions',
		label: 'Aktionen',
		align: 'right',
		width: 160,
		render: (row) => <RestoreButton onClick={() => onRestore(row)} disabled={isRestoring} />,
	};

	return (
		<Table
			rows={rows}
			columns={[...columns, actionColumn]}
			emptyLabel={emptyLabel}
			pagination={{ currentPage: page, totalPages, onPageChange, totalItems: total, pageSize: TRASH_PAGE_SIZE }}
			{...tableProps}
		/>
	);
}

TrashTable.propTypes = {
	rows: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	page: PropTypes.number.isRequired,
	totalPages: PropTypes.number.isRequired,
	total: PropTypes.number,
	onPageChange: PropTypes.func.isRequired,
	onRestore: PropTypes.func.isRequired,
	isRestoring: PropTypes.bool,
	emptyLabel: PropTypes.string,
};

export default TrashTable;
